const STORAGE_KEY = "sgc.wv.tokens";

export const REFRESH_SKEW_SECONDS = 30;

export interface IssuedTokens {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
}

export interface StoredTokens {
  accessToken: string;
  expiresAt: number;
  refreshToken: string;
}

export function readTokens(): StoredTokens | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;

    const stored: Partial<StoredTokens> | null = JSON.parse(raw);
    if (!stored) return null;

    const { accessToken, refreshToken, expiresAt } = stored;
    if (!accessToken || !refreshToken) return null;
    if (typeof expiresAt !== "number" || !Number.isFinite(expiresAt)) {
      return null;
    }

    return { accessToken, expiresAt, refreshToken };
  } catch {
    return null;
  }
}

export function writeTokens(issued: IssuedTokens): StoredTokens {
  const stored: StoredTokens = {
    accessToken: issued.accessToken,
    expiresAt: Date.now() + issued.expiresIn * 1000,
    refreshToken: issued.refreshToken,
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));

  return stored;
}

export function clearTokens(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

/** True while the access token has more than the skew left to live. */
export function isFresh(tokens: StoredTokens): boolean {
  return tokens.expiresAt - Date.now() > REFRESH_SKEW_SECONDS * 1000;
}
